import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./Layout/layout.tsx";
import AuthenticatedRoute from "./Auth/AuthenticatedRoute.tsx";
import AdminRoute from "./Auth/AdminRoute.tsx";
import TimeEntries from "./Pages/TimeEntries.tsx";

const ActiveEngagementGrid = lazy(() => import("./Pages/ActiveEngagement.tsx"));
const FavoriteCard = lazy(() => import("./Pages/FavoriteCard.tsx"));
const EngagementLayout = lazy(() => import("./Components/EngagementLayout.tsx"));
const WorkflowPreview = lazy(() => import("./Components/WorkflowPreviewPage.tsx"));
const ViewRequests = lazy(() => import("./Pages/ViewRequests.tsx"));
const RequestTypes = lazy(() => import("./Pages/RequestNavigator.tsx"));
const IndividualTimeReport = lazy(() => import("./Pages/IndividualTimeReport.tsx"));
const AdminLayout = lazy(() => import("./Pages/Admin/AdminLayout.tsx"));

const routes = [
  { path: "/", component: FavoriteCard },
  { path: "/engagements", component: ActiveEngagementGrid },
  { path: "/overview/:engagementId", component: EngagementLayout },
  { path: "/budget/:engagementId", component: EngagementLayout },
  { path: "/monitor/:engagementId", component: EngagementLayout },
  { path: "/requests/:engagementId", component: EngagementLayout },
  { path: "/expenses/:engagementId", component: EngagementLayout },
  { path: "/workflow/:engagementId", component: EngagementLayout },
  { path: "/workflow-preview", component: WorkflowPreview },
  { path: "/budget/", component: EngagementLayout },
  { path: "/monitor/", component: EngagementLayout },
  { path: "/viewrequests", component: ViewRequests },
  { path: "/timeentries/:engagementId", component: EngagementLayout },
  { path: "/viewrequests/:requestKey", component: ViewRequests },
  { path: "/requests", component: RequestTypes },
  { path: "/overview/:engagementId", component: EngagementLayout },
  { path: "/time-report", component: IndividualTimeReport },
  { path: "/admin", component: AdminLayout },
  { path: "/admin/:section", component: AdminLayout },
];

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {routes.map(({ path, component: Component }, index) => (
          <Route
            key={`${index}-${Component.name}`}
            path={path}
            element={
              <AuthenticatedRoute>
                <Suspense>
                  <div
                    className={`main-contain ${Component === EngagementLayout
                        ? "engagement-layout"
                        : Component === AdminLayout
                          ? "admin-layout"
                          : ""
                      }`.trim()}
                  >
                    {Component === AdminLayout ? (
                      <AdminRoute>
                        <Component />
                      </AdminRoute>
                    ) : (
                      <Component />
                    )}
                  </div>
                </Suspense>
              </AuthenticatedRoute>
            }
          />
        ))}
        <Route path="/favorites" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};